import { EParamsName } from "single-spa/react-app/router/types";

import { cleanUrlParams } from "./paramsRouting/utils";

export const cleanNewLoaderParams = (urlParams: URLSearchParams) => {
    const paramsToRemoveFromUrl = [EParamsName.LOCALE, EParamsName.WEBSITE, EParamsName.SHOULD_SHOW_LOADER];

    cleanUrlParams(urlParams, paramsToRemoveFromUrl);
};
